export default __webpack_public_path__ + "static/media/AkshitaSah - 5286_Akshita Sah.4cbf7349.jpeg";